export default __webpack_public_path__ + "static/media/laptop.cd585c78.png";